export class DropdownModelBoolean {
    constructor(public id: boolean, public text: string) { }
  }
